const API = 'https://backend.fibriya.hu/public/shopify-search/search';
const language = (document.documentElement.lang || 'de').split('-')[0];
const locale = language === 'cs' ? 'cz' : language;
const labels = {
 de:['Produkte','Rezepte','Alle Produkte anzeigen','Alle Rezepte anzeigen','In den Warenkorb','Ausverkauft','Optionen wählen','Hinzugefügt ✓','Keine passenden Ergebnisse.','Weitere Ergebnisse laden','Erneut versuchen','Suche vorübergehend nicht verfügbar.','Preis wird geladen…'],
 pl:['Produkty','Przepisy','Zobacz wszystkie produkty','Zobacz wszystkie przepisy','Dodaj do koszyka','Wyprzedane','Wybierz opcje','Dodano ✓','Brak pasujących wyników.','Załaduj więcej','Spróbuj ponownie','Wyszukiwanie jest chwilowo niedostępne.','Ładowanie ceny…'],
 sk:['Produkty','Recepty','Zobraziť všetky produkty','Zobraziť všetky recepty','Do košíka','Vypredané','Vybrať možnosti','Pridané ✓','Žiadne zodpovedajúce výsledky.','Načítať ďalšie','Skúsiť znova','Vyhľadávanie je dočasne nedostupné.','Načítava sa cena…'],
 cz:['Produkty','Recepty','Zobrazit všechny produkty','Zobrazit všechny recepty','Do košíku','Vyprodáno','Vybrat možnosti','Přidáno ✓','Žádné odpovídající výsledky.','Načíst další','Zkusit znovu','Vyhledávání je dočasně nedostupné.','Načítá se cena…'],
 hu:['Termékek','Receptek','Összes termék megtekintése','Összes recept megtekintése','Kosárba','Elfogyott','Válassz változatot','Hozzáadva ✓','Nincs megfelelő találat.','További találatok','Újrapróbálás','A kereső átmenetileg nem érhető el.','Ár betöltése…']
}[locale] || [];
const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const ownPath = value => {
 const url = new URL(value, location.origin);
 if (url.origin !== location.origin) throw new Error('Storefront URL mismatch');
 return url.pathname;
};
const root = () => window.Shopify?.routes?.root || '/';
const recipeBlogs={de:'keto-low-carb-rezepte',pl:'przepisy-keto-i-low-carb',sk:'keto-a-low-carb-recepty',cz:'keto-a-low-carb-recepty',hu:'keto-low-carb-receptek'};
const fullLink = (q, kind) => kind==='recipe'
 ? root()+'blogs/'+recipeBlogs[locale]+'?'+new URLSearchParams({q})
 : root()+'search?'+new URLSearchParams({q,fs_kind:kind});
const moreLabels={de:['Weitere Produkte','Weitere Rezepte'],pl:['Więcej produktów','Więcej przepisów'],sk:['Ďalšie produkty','Ďalšie recepty'],cz:['Další produkty','Další recepty'],hu:['További terméktalálatok','További recepttalálatok']}[locale];
const allProductsLabel={de:'Alle Produkte',pl:'Wszystkie produkty',sk:'Všetky produkty',cz:'Všechny produkty',hu:'Összes termék'}[locale];
const cache = new Map();

async function rawSearch(q, kind, limit, offset, signal) {
 const response=await fetch(API+'?'+new URLSearchParams({q,locale,kind,limit,offset}),{signal,credentials:'omit'});
 if (!response.ok) throw new Error('Search unavailable');
 return response.json();
}

async function collectionSection(name, next) {
 const url=new URL(next||root()+'collections/all',location.origin);
 if(url.origin!==location.origin)throw new Error('Storefront mismatch');
 url.searchParams.set('sort_by','best-selling');url.searchParams.set('section_id',name);
 const response=await fetch(url,{credentials:'same-origin'});
 if(!response.ok)throw new Error('Storefront availability unavailable');
 return new DOMParser().parseFromString(await response.text(),'text/html');
}

// Search remains complete, including unavailable products. Availability is
// shown on each card; only the default bestseller selection is stock-filtered.
async function search(q,kind,limit,offset,signal) {
 return rawSearch(q,kind,limit,offset,signal);
}

async function product(url) {
 const path=ownPath(url);
 const current=cache.get(path);
 if(current && Date.now()-current.at<30000) return current.value;
 const response=await fetch(path+'.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
 if(!response.ok) throw new Error('Product unavailable');
 const value=await response.json();cache.set(path,{value,at:Date.now()});return value;
}

function card(item, kind) {
 const href=ownPath(item.url);
 const id='fs-product-'+String(item.source_id).split('/').pop();
 const image=item.image_url && /^https:\/\//.test(item.image_url) ? `<img src="${esc(item.image_url)}" alt="${esc(item.title)}" width="500" height="625" loading="lazy">` : '';
 const quick=kind==='product'?`<div class="quick-add fs-quick-add color-scheme-1">
  <product-form-component id="${esc(id)}" data-product-id="${esc(String(item.source_id).split('/').pop())}" on:submit="/handleSubmit">
   <form method="post" action="${esc(root()+'cart/add')}" id="${esc(id)}-form" data-type="add-to-cart-form">
    <input type="hidden" name="id" ref="variantId"><input type="hidden" name="quantity" value="1">
    <add-to-cart-component ref="addToCartButtonContainer">
     <button type="button" ref="addToCartButton" class="fs-add button quick-add__button quick-add__button--add" disabled data-product-url="${esc(href)}" aria-label="${esc(labels[4])}">
      <span class="add-to-cart-text"><span class="svg-wrapper add-to-cart-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"/></svg></span><span class="add-to-cart-text__content is-visually-hidden-mobile">${esc(labels[4])}</span></span>
      <span aria-hidden="true" class="add-to-cart-text--added"><span class="svg-wrapper add-to-cart-icon--added"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="is-visually-hidden-mobile">${esc(labels[7].replace(' ✓',''))}</span></span>
     </button>
    </add-to-cart-component>
    <span ref="liveRegion" class="fs-feedback" aria-live="polite"></span>
    <span ref="addToCartTextError" class="fs-cart-error hidden" role="alert"></span>
   </form>
  </product-form-component>
 </div>`:'';
 return `<li class="fs-card predictive-search-results__card" ref="resultsItems[]" data-source-id="${esc(item.source_id)}">
  <div class="fs-media"><a class="fs-card-link" href="${esc(href)}"><div class="fs-image">${image}</div></a>${quick}${kind==='product'?`<span class="fs-sold-out" hidden>${esc(labels[5])}</span>`:''}</div>
  <a class="fs-card-link fs-title" href="${esc(href)}">${esc(item.title)}</a>
  ${kind==='product'?`<div class="fs-price" aria-live="off">${esc(labels[12])}</div>`:''}
 </li>`;
}

function list(items,kind) {
 return `<ul class="fs-grid predictive-search-results__list" aria-label="${esc(labels[kind==='product'?0:1])}">${items.map(i=>card(i,kind)).join('')}</ul>`;
}

// Called by the existing theme component; it retains debounce, cancellation,
// focus handling and DOM morphing. Prices and variants are always storefront-local.
const ingredientsHeading={de:'Zutaten für diese Rezepte',pl:'Składniki do tych przepisów',sk:'Prísady pre tieto recepty',cz:'Ingredience pro tyto recepty',hu:'Hozzávalók ezekhez a receptekhez'}[locale];
function titleSearchText(value) {
 return String(value).toLocaleLowerCase().replaceAll('ß','ss').replaceAll('ł','l').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
}
// General catalogue attributes remain shopping queries. These affect ordering
// only; every displayed product must still match the actual search index.
const catalogueQueries=new Set([
 'keto','low carb','lowcarb',
 ...({
  de:['glutenfrei','gluten free','zuckerfrei','ohne zucker','ohne zuckerzusatz','kohlenhydratarm'],
  pl:['bezglutenowe','bezglutenowy','bez glutenu','bez cukru','niskowęglowodanowe','słodzik','czekolada','wanilia'],
  sk:['bezlepkové','bezlepkový','bez lepku','bez cukru','nízkosacharidové','sladidlo','čokoláda','vanilka'],
  cz:['bezlepkové','bezlepkový','bez lepku','bez cukru','nízkosacharidové','sladidlo','čokoláda','vanilka'],
  hu:['gluténmentes','cukormentes','szénhidrátcsökkentett','alacsony szénhidráttartalmú','édesítő','édesítőszer']
 }[locale]||[])
].map(titleSearchText));
function recipeFirst(q,products,recipes) {
 if(products.alias_match_count>0||products.title_match_count>0)return false;
 q=products.effective_query||recipes.effective_query||q;
 const terms=titleSearchText(q).split(' ').filter(Boolean);
 if(!terms.length||!recipes.result_count)return false;
 if(products.result_count&&catalogueQueries.has(titleSearchText(q)))return false;
 return !products.results.some(product=>{
  const title=titleSearchText(product.title);
  // Tiny terms must start a title word: "Ei" must not match "Weizenmehl".
  // Longer terms still match compound product names such as "Bauernbrot".
  const words=title.split(' ');
  return terms.every(term=>term.length<=2?words.some(word=>word.startsWith(term)):title.includes(term));
 });
}

export async function predictiveMarkup(q, signal) {
 const [products,recipes]=await Promise.all([search(q,'product',8,0,signal),search(q,'recipe',4,0,signal)]);
 const recipesLead=recipeFirst(q,products,recipes);
 const shownProducts=recipesLead?products.results.slice(0,4):products.results;
 const shownRecipes=recipesLead?recipes.results.slice(0,2):recipes.results;
 const p=shownProducts.length?list(shownProducts,'product'):`<p>${esc(labels[8])}</p>`;
 const r=shownRecipes.length?list(shownRecipes,'recipe'):`<p>${esc(labels[8])}</p>`;
 const productBlock=recipesLead&&!shownProducts.length?'':`<h4 class="fs-heading">${esc(recipesLead?ingredientsHeading:labels[0])}</h4>${p}
  ${products.result_count>shownProducts.length?`<a class="fs-all button" href="${esc(fullLink(q,'product'))}">${esc(moreLabels[0])}</a>`:''}`;
 const seeAll={de:'Alle ansehen',pl:'Zobacz wszystkie',sk:'Zobraziť všetky',cz:'Zobrazit všechny',hu:'Összes megtekintése'}[locale];
 const recipeHeading=recipesLead?`<div class="fs-heading-row"><h4 class="fs-heading">${esc(labels[1])}</h4><a class="fs-heading-link" href="${esc(fullLink(q,'recipe'))}">${esc(seeAll)}</a></div>`:`<h4 class="fs-heading">${esc(labels[1])}</h4>`;
 const recipeBlock=`${recipeHeading}${r}
  ${!recipesLead&&recipes.result_count>shownRecipes.length?`<a class="fs-all button" href="${esc(fullLink(q,'recipe'))}">${esc(moreLabels[1])}</a>`:''}`;
 return `<div id="predictive-search-results" class="predictive-search-dropdown" aria-label="${esc(q)}">
  <div class="predictive-search-results__inner" data-search-results><fibriya-search-results data-search-intent="${recipesLead?'recipe':'product'}">
  ${recipesLead?recipeBlock+productBlock:productBlock+recipeBlock}
  </fibriya-search-results></div></div>`;
}

let bestsellersRequest,bestsellersAt=0;
export async function emptyMarkup(signal) {
 // Localized, sales-ranked Shopify collection; never guess popularity from
 // alphabetic index order. One request is shared by reset/open operations.
 if(Date.now()-bestsellersAt>30000)bestsellersRequest=null;
 if(!bestsellersRequest){bestsellersAt=Date.now();bestsellersRequest=(async()=>{
  const items=[];let next=null;const visited=new Set();
  do {
   if(visited.has(next))throw new Error('Repeated bestseller page');visited.add(next);
   const doc=await collectionSection('fibriya-search-bestsellers',next);
   const data=JSON.parse(doc.querySelector('[data-fibriya-bestsellers]').textContent);
   if(data.sort!=='best-selling'||data.collection!=='all'||!Array.isArray(data.products))throw new Error('Invalid bestseller order');
   items.push(...data.products);next=data.next;
  }while(items.length<8&&next);
  return items.slice(0,8);
 })().catch(error=>{bestsellersRequest=null;throw error;});}
 const items=await bestsellersRequest;
 if(signal.aborted)throw new DOMException('Aborted','AbortError');
 const heading={de:'Bestseller',pl:'Najpopularniejsze produkty',sk:'Najobľúbenejšie produkty',cz:'Nejoblíbenější produkty',hu:'Legnépszerűbb termékek'}[locale]||labels[0];
 return `<div class="predictive-search-empty-section"><div class="predictive-search-results__inner" data-search-results><fibriya-search-results><h4 class="fs-heading">${esc(heading)}</h4>${list(items,'product')}<a class="fs-all button" href="${esc(root()+'collections')}">${esc(allProductsLabel)}</a></fibriya-search-results></div></div>`;
}

function setAddLabel(button, text) {
 button.querySelector('.add-to-cart-text__content').textContent=text;
 button.setAttribute('aria-label',text);
}

function animateSearchAdd(button) {
 // Reuse Horizon's registered button and FlyToCart components, including its
 // curve, duration and cleanup. A modal's top layer would hide a body child.
 try {
  button.closest('add-to-cart-component')?.animateAddToCart?.();
  const enabled=document.querySelector('script[data-fibriya-search-asset]')?.dataset.addToCartAnimation==='true';
  if(!enabled || matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const destination=document.querySelector('.header-actions__cart-icon');
  const image=button.closest('.fs-card').querySelector('.fs-image img');
  if(!destination || !image || !customElements.get('fly-to-cart'))return;
  const fly=document.createElement('fly-to-cart');
  fly.style.setProperty('background-image',`url("${image.currentSrc||image.src}")`);
  fly.source=button;fly.destination=destination;
  (button.closest('dialog[open]')||document.body).appendChild(fly);
 } catch(error) { console.warn('Search cart animation unavailable'); }
}

class SearchResults extends HTMLElement {
 connectedCallback() {
  this.controller=new AbortController();
  this.addEventListener('click',event=>this.add(event),{signal:this.controller.signal});
  this.hydrate();
  this.observer=new MutationObserver(()=>this.hydrate());
  this.observer.observe(this,{childList:true,subtree:true});
 }
 disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();}
 hydrate() {
  for(const button of this.querySelectorAll('[data-product-url]:not([data-hydrated])')) {
   button.dataset.hydrated='pending';
   product(button.dataset.productUrl).then(value=>{
    if(!button.isConnected)return;
    const cell=button.closest('.fs-card');
    const currency=window.Shopify?.currency?.active;
    cell.querySelector('.fs-price').textContent=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:currency||'EUR'}).format(value.price/100);
    const available=value.variants.filter(v=>v.available);
    if(!available.length){setAddLabel(button,labels[5]);button.disabled=true;button.closest('.fs-quick-add').hidden=true;cell.querySelector('.fs-sold-out').hidden=false;}
    else if(value.variants.length>1){setAddLabel(button,labels[6]);button.dataset.options='true';button.disabled=false;}
    else{button.dataset.variant=available[0].id;cell.querySelector('input[name="id"]').value=available[0].id;button.type='submit';button.disabled=false;}
    button.dataset.hydrated='true';
   }).catch(()=>{
    if(!button.isConnected)return;
    button.closest('.fs-card').querySelector('.fs-price').textContent='';
    setAddLabel(button,labels[6]);button.dataset.options='true';button.disabled=false;button.dataset.hydrated='true';
   });
  }
 }
 add(event) {
  const button=event.target.closest('.fs-add');
  if(!button || !this.contains(button) || button.disabled)return;
  if(button.dataset.options){event.preventDefault();location.href=button.dataset.productUrl;return;}
  // The category-page product-form component handles the submit directly.
  // No serial product/cart GET before adding; Shopify validates live stock.
  // Run the same button/fly feedback immediately, including inside a dialog.
  animateSearchAdd(button);
 }

}
if(!customElements.get('fibriya-search-results'))customElements.define('fibriya-search-results',SearchResults);

class FullSearch extends HTMLElement {
 connectedCallback() {
  const params=new URLSearchParams(location.search);this.q=params.get('q')||'';this.kind=params.get('fs_kind')==='recipe'?'recipe':'product';this.autoKind=!['product','recipe'].includes(params.get('fs_kind'));this.offset=0;this.total=0;this.loading=false;
  this.innerHTML=`<div class="fs-tabs" role="tablist"><button type="button" role="tab" data-kind="product">${esc(labels[0])}</button><button type="button" role="tab" data-kind="recipe">${esc(labels[1])}</button></div><p class="fs-count" role="status"></p><fibriya-search-results><ul class="fs-grid fs-full-grid"></ul></fibriya-search-results><button type="button" class="fs-more button" hidden>${esc(labels[9])}</button>`;
  this.list=this.querySelector('ul');this.more=this.querySelector('.fs-more');
  this.controller=new AbortController();
  this.addEventListener('click',e=>{const tab=e.target.closest('[data-kind]');if(tab&&tab.dataset.kind!==this.kind){this.autoKind=false;this.kind=tab.dataset.kind;this.offset=0;this.load(false);history.replaceState(null,'',fullLink(this.q,this.kind));}else if(e.target===this.more)this.load(this.failed?this.failedAppend:true);},{signal:this.controller.signal});
  this.intersection=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&!this.more.hidden&&!this.loading&&!this.failed)this.load(true);},{rootMargin:'300px'});
  this.intersection.observe(this.more);this.load(false);
 }
 disconnectedCallback(){this.controller?.abort();this.request?.abort();this.intersection?.disconnect();}
 async load(append) {
  if(append&&this.loading)return;
  this.request?.abort();const request=new AbortController();this.request=request;
  this.loading=true;this.failed=false;this.more.disabled=true;
  const offset=append?this.offset:0;let kind=this.kind;
  this.querySelectorAll('[data-kind]').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.kind===kind)));
  try {
   let result;
   if(this.autoKind){
    const [products,recipes]=await Promise.all([search(this.q,'product',24,0,request.signal),search(this.q,'recipe',24,0,request.signal)]);
    if(request.signal.aborted)return;
    kind=recipeFirst(this.q,products,recipes)?'recipe':'product';
    this.kind=kind;this.autoKind=false;result=kind==='recipe'?recipes:products;
    this.querySelectorAll('[data-kind]').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.kind===kind)));
   }else result=await search(this.q,kind,24,offset,request.signal);
   if(request.signal.aborted)return;
   if(!append)this.list.replaceChildren();
   const existing=new Set([...this.list.children].map(c=>c.dataset.sourceId));
   for(const item of result.results)if(!existing.has(item.source_id)){this.list.insertAdjacentHTML('beforeend',card(item,kind));existing.add(item.source_id);}
   this.offset=offset+result.results.length;this.total=result.result_count;
   this.querySelector('.fs-count').textContent=`${this.list.children.length} / ${this.total}`;
   this.more.hidden=this.offset>=this.total;this.more.textContent=labels[9];
  }catch(error){if(error.name!=='AbortError'){this.failed=true;this.failedAppend=append;this.querySelector('.fs-count').textContent=labels[11];this.more.hidden=false;this.more.textContent=labels[10];}}
  finally{if(this.request===request){this.loading=false;this.more.disabled=false;}}
 }
}
if(!customElements.get('fibriya-full-search'))customElements.define('fibriya-full-search',FullSearch);
